import React, {useEffect, useState} from "react";
import "./style.scss";

export const TargetWeightResult = ({cur, tar}) => {
  const renderText = () => {
    const tarKg = tar.getWeightWithUnitKG();
    const curKg = cur.getWeightWithUnitKG();
    const change = Math.round(((tarKg - curKg) / curKg) * 100);
    let title = "";
    let color = '';
    let message = '';

    if (change < -10) {
      title = "Reasonable goal";
      color = '#ED6720'; // 橙色
      message = 'Scientific evidence indicates that losing 10% or more of your body weight can improve various obesity-related conditions.';
    } else if (change >= -10 && change < 0) {
      title = "Easy win";
      color = '#4FA463'; // 灰色
      message = 'Scientific evidence shows that overweight individuals are more likely to improve metabolic health with some weight loss.';
    } else if (change >= 0 && change < 10) {
      title = "Easy win";
      color = '#4FA463'; // 灰色
      message = 'A moderate increase in weight can make a big difference.';
    } else if (change >= 10 && change < 20) {
      title = "Reasonable goal";
      color = '#ED6720'; // 橙色
      message = 'You will get continuous health benefits with higher muscle ratio.';
    } else if (change >= 20) {
      title = "Challenging goal";
      color = '#F52121'; // 红色
      message = 'You can see more significant benefits with your muscle gain.';
    }

    return {title, color, message};
  };

  const {title, color, message} = renderText();


  return (
    <div className="target-weight-bmi">
      <div className={'current-weight-bmi-title'} style={{color}}>
        {title}:
      </div>
      <div className={'current-weight-bmi-content'}>
        {message}
      </div>
    </div>
  );
};
